import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";

const ToggleWithText = ({
  options = ["FBA", "FBM"], // Array of two options
  value, // Controlled value
  defaultValue, // Uncontrolled default value
  onChange,
  useRedux = false, // Option to sync with Redux
  reduxSelector, // Redux selector function
  reduxValue, // Redux value to match against
}) => {
  // Determine initial value (always call hooks in the same order)
  const reduxSelectedFulfillment = useSelector(
    (state) => state.globalStates.selectedFulfillment
  );

  const getInitialValue = () => {
    if (value !== undefined) return value; // Controlled
    if (useRedux && reduxSelectedFulfillment) return reduxSelectedFulfillment;
    if (defaultValue !== undefined) return defaultValue;
    return options[0]; // Default to first option
  };

  const [selectedValue, setSelectedValue] = useState(getInitialValue);

  // Sync with controlled value
  useEffect(() => {
    if (value !== undefined) {
      setSelectedValue(value);
    }
  }, [value]);

  // Sync with Redux if enabled
  useEffect(() => {
    if (useRedux && reduxSelectedFulfillment) {
      setSelectedValue(reduxSelectedFulfillment);
    }
  }, [reduxSelectedFulfillment, useRedux]);

  const handleOptionClick = (option) => {
    if (option === selectedValue) return; // Already selected

    setSelectedValue(option);
    if (onChange) {
      onChange(option);
    }
  };

  return (
    <div className="flex items-center gap-2 py-0.5 bg-primary-bg rounded-md">
      {options.map((option, index) => (
        <button
          key={index}
          onClick={() => handleOptionClick(option)}
          className={`px-3 py-1 rounded-lg text-sm font-semibold transition-all duration-200 outline-none ${
            selectedValue === option
              ? "bg-primary text-secondary"
              : "text-primary"
          }`}
        >
          {option}
        </button>
      ))}
    </div>
  );
};

export default ToggleWithText;